import { FC } from 'react'
import Link from 'next/link'
import styles from '../../styles/Applications.module.scss'
import { Col, Row, Button, Image, Card } from 'react-bootstrap'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'

interface JobProps {
	id: number,
	companyAvatar: string,
	companyName: string,
	jobTitle: string,
	jobSalaries: any,
	hideSalaries: any,
	jobCreated: string
}

const JobCard: FC<JobProps> = (props): JSX.Element => {
	const router = useRouter()
	const locale = router.locale
	const { t } = useTranslation()

	const getSalTyp = (val) => {
		switch (val) {
		case 'PER DAY':
			return t('root.day')
		case 'PER HOUR':
			return t('root.hour')
		case 'PER MONTH':
			return t('root.month')
		case 'PER WEEK':
			return t('root.week')
		default:
			return t('root.month')
		}
	}

	const slugify = (str) => {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return str.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	}

	return (
		<>
			<Col xl={3} lg={6} md={6} sm={6} xs={12} className='mt-4'>
				<Link href={`/${locale}/job/${slugify(props.jobTitle)}-${props.id}`} passHref>
					<a className='text-decoration-none'>
						<Card className={styles.card}>
							{!props.companyAvatar && <div className={styles.companyNoAvatar}>{props.companyName}</div>}
							{props.companyAvatar && <Image src={props.companyAvatar} className={styles.companyAvatar} alt={props.companyName.substring(0, 10)} />}
							<Row className={styles.jobDesc}>
								<span className={styles.jobtitle}>{props.jobTitle}</span>
								<span className={styles.companyName}>{props.companyName}</span>
							</Row>
							<div className={styles.cardBottom}>
								{!props.hideSalaries && props.jobSalaries?.map((js, i) => {
									return (
										<p key={i} className={styles.jobSalary}>
											{js.min > 0 ? `${locale?.toUpperCase() === 'SG' ? '$' : locale?.toUpperCase() === 'MY' ? 'RM' : '$'} ${js.min}` : '$0'}
											{js.min > 0 && js.max > 0 ? ' - ' : ''}
											{js.max > 0 ? `${locale?.toUpperCase() === 'SG' ? '$' : locale?.toUpperCase() === 'MY' ? 'RM' : '$'} ${js.max}` : '$0'}
											/ {js.salaryType === null ? t('root.month') : getSalTyp(js.salaryType)}
										</p>
									)
								})}
								<Link href={`/${locale}/job/${slugify(props.jobTitle)}-${props.id}`} passHref>
									<Button variant='primary' size='lg' className={styles.buttonApplied}>{t('job.vdetails')}</Button>
								</Link>
								<p className={styles.jobCreaDate}>{t('applied.applied_on')} {dayjs(props.jobCreated).format('DD MMM YYYY')}</p>
							</div>
						</Card>
					</a>
				</Link>
			</Col>
		</>
	)
}

export default JobCard